enum FieldExportType {
  shape = 'shape',
  isoXml = 'iso-xml',
}

export default FieldExportType;
